import { Navigate, Route, Routes } from "react-router";
import { ProtectedRoute } from "@/components/protected-route";
import { FullScreenLoader } from "@/components/spinner";
import { LoginScreen, NoAccessScreen } from "@/screens/login";
import { MyTripsScreen } from "@/screens/my-trips";
import { TripDetailScreen } from "@/screens/trip-detail";
import { ProfileScreen } from "@/screens/profile";
import { ScheduleScreen } from "@/screens/schedule";
import { CollectionScreen } from "@/screens/collection";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/no-access" element={<NoAccessScreen />} />
      {/* Auth0 redirects here; the SDK exchanges the code, then navigates to / */}
      <Route
        path="/callback"
        element={<FullScreenLoader label="Signing in…" />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MyTripsScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trips/:tripId"
        element={
          <ProtectedRoute>
            <TripDetailScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trips/:tripId/collection"
        element={
          <ProtectedRoute>
            <CollectionScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfileScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/schedule"
        element={
          <ProtectedRoute>
            <ScheduleScreen />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
